const TeacherPortalStudentGeneralInformationTab = ({ student }) => {
    return <p>Student ID: {student.user.userid}</p>
}


export default TeacherPortalStudentGeneralInformationTab